const actions = {
    async list({ rootGetters }, { params }) {
        return await this.getDataStore(`${rootGetters.API_URL}/payments`, params);
    },
    async createReport({ rootGetters }, { params }) {
        return await this.postDataStore(`${rootGetters.API_URL}/payments/create_export_download`, params);
    },
    async checkReport({ rootGetters }, file_name) {
        return await this.getDataStore(`${rootGetters.API_URL}/search_export_file?`, { file_name });
    }
};
export default {
    namespaced: true,
    actions
};
